/**
 * Strip runtime / execution fields from plan step objects used for UI layout.
 * Keep in sync with stripExecutionRuntimeAndReplayState in automationStudioSlice.
 * Displayed execution state must come from WebSocket (replayExecutionResults, etc.), not embedded plan data.
 */
export function sanitizePlanStep(step) {
    if (!step || typeof step !== 'object') return step;
    const {
        status,
        executionGroup,
        passed,
        confidence,
        actualOutcome,
        actual_outcome,
        details,
        error,
        reason,
        failureReason,
        failure_reason,
        duration,
        screenshot,
        resultMessage,
        result,
        ...clean
    } = step;
    return clean;
}

export function sanitizePlanSteps(steps) {
    if (!Array.isArray(steps)) return [];
    return steps.map(sanitizePlanStep);
}

/**
 * Normalize replayPlan payloads from the agent WebSocket (shape varies).
 */
export function extractReplayPlanSteps(replayPlan) {
    if (!replayPlan || typeof replayPlan !== 'object') return [];
    const nested = replayPlan.planJson ?? replayPlan.plan ?? replayPlan;
    const steps = nested?.steps ?? replayPlan.steps;
    return Array.isArray(steps) ? steps : [];
}
